import { Box, Button, Checkbox, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import MultiSelectDropDown from '../../../form-components/MultiSelectDropDownComponent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import TablePaginationCustom from '../../../common/TablePagination'
import { LinkPlaceColumnDefs, LinkPlaceColumnDefsForPdfExcel, transparentStyle, statusList } from '../mastersConfigConstants'
import VisibilityIcon from '@mui/icons-material/Visibility';
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { Edit } from '../../../../assets/Icons/Edit'
import Alert from '../../../common/Alert'
import AddLevies from './AddLinkPlaceConfig'
import EditLevies from './EditLinkPlaceConfig'
import ViewLevies from './ViewLinkPlaceConfig'
import { useDispatch, useSelector } from 'react-redux'
import { getplaceListAll, getLinkPlaceList } from '../../../../redux/KSRTC_Redux/MasterConfig/MasterAction'
import moment from 'moment'
import ReportHeader from '../../../common/ReportHeader'
import PrintIcon from '@mui/icons-material/Print'
import { focusElemnt, navigation3 } from '../../../../utilityFunctions'
import { masterConfigMenuVSBL } from '../../../../redux/Actions'
import { updateLoadingScreen } from '../../../../redux/Actions'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import excelExport from '../../../../assets/extra/export-excel'

const LinkPlaceConfig = () => {
  const dispatch = useDispatch()
  const userState = useSelector((store) => store.user);
  const { placeList } = useSelector((store) => store.masterConfig);
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(0)
  const [tableData, setTableData] = useState([])
  const [reportData, setReportData] = useState([])
  const [data, setData] = useState({})
  const [showAlert, setShowAlert] = useState({
    msg: '',
    open: false
  });
  const [searchData, setSearchData] = useState({
    FromCity: "",
    LinkCity: "",
    ToCity: "",
    StartDT: "",
    EndDT: "",
    CreatedBy: "",
    CreatedDT: "",
    // ModifiedBy: '',
    // ModifiedDT: ''
  })
  const [masterEdit, setMasterConfigEdit] = useState(false)
  const [masterAdd, setMasterConfigAdd] = useState(false)
  const [masterView, setMasterConfigView] = useState(false)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const [filterValue, setFilterValue] = useState({
    startPlace: placeList,
    linkPlace: placeList,
    endPlace: placeList,
    status: [statusList[1]]
  })
  const [filterOpt, setFilterOpt] = useState({
    startPlace: placeList,
    linkPlace: placeList,
    endPlace: placeList,
  })
  const LoginId = sessionStorage.getItem('LoginId')
  const handleEdits = (val) => {
    setMasterConfigEdit(val)
  }
  const handleAdd = (val) => {
    setMasterConfigAdd(val)
  }
  const handleView = (val) => {
    setMasterConfigView(val)
  }
  useEffect(() => {
    if (userState?.CompanyID) {
      const placeBody = {
        CityID: 0,
        StateID: 0,
        AttachCityID: 0,
        AttachBranchID: 0,
      }
      dispatch(getplaceListAll(placeBody))
    }
    let obj = {
      CompanyID: userState?.CompanyID,
      UserID: userState?.UserID,
      FromCityID: 0,
      LinkCityID: 0,
      ToCityID: 0,
      IsActive: 1
    }
    dispatch(getLinkPlaceList(obj)).then((res) => {
      if (res?.status === 200 && res?.data?.status) {
        setTableData(res?.data?.Data?.Table)
        setReportData(res?.data?.Data?.Table)
      } else {
        setTableData([])
        setReportData([])
        handleSetAlert(res?.data?.Message);
      }
    }).catch((error) => {
      console.log("Error: ", error);
    });

    focusElemnt('lvCorpCode')
  }, [userState?.CompanyID])
  // useEffect(() => {
  //   if (placeList?.length > 0) {
  //     setFilterOpt({
  //       startPlace: placeList, endPlace: placeList, linkPlace: placeList
  //     })
  //   }
  // }, [placeList])
  const getTableData = () => {
    let obj = {
      CompanyID: userState?.CompanyID,
      UserID: userState?.UserID,
      FromCityID: filterValue?.startPlace?.length === 1 ? filterValue?.startPlace[0]?.CityID : 0,
      LinkCityID: filterValue?.linkPlace?.length === 1 ? filterValue?.linkPlace[0]?.CityID : 0,
      ToCityID: filterValue?.endPlace?.length === 1 ? filterValue?.endPlace[0]?.CityID : 0,
      IsActive: filterValue?.status?.length === 1 ? filterValue?.status[0]?.id : -1
    }
    dispatch(getLinkPlaceList(obj)).then((res) => {
      if (res?.status === 200 && res?.data?.status) {
        setTableData(res?.data?.Data?.Table)
        setReportData(res?.data?.Data?.Table)
      } else {
        setTableData([])
        setReportData([])
        handleSetAlert(res?.data?.Message);
      }
    }).catch((error) => {
      console.log("Error: ", error);
    });
  }

  const handleSetAlert = (msg) => {
    setShowAlert((prev) => ({ ...prev, msg: msg, open: true }))
  }
  const handleAlertClose = () => {
    setShowAlert((prev) => ({ ...prev, msg: '', open: false }))
  }
  useEffect(() => {
    let fiterData = reportData.filter((val) =>
      (searchData?.FromCity === "" || (val?.FromCity && val?.FromCity?.toLocaleLowerCase().includes(searchData?.FromCity?.toLocaleLowerCase()))) &&
      (searchData?.LinkCity === "" || (val?.LinkCity && val?.LinkCity?.toLocaleLowerCase().includes(searchData?.LinkCity?.toLocaleLowerCase()))) &&
      (searchData?.ToCity === "" || (val?.ToCity && val?.ToCity?.toLocaleLowerCase().includes(searchData?.ToCity?.toLocaleLowerCase()))) &&
      (searchData?.StartDT === "" || (val?.StartDT && val?.StartDT?.toLocaleLowerCase().includes(searchData?.StartDT?.toLocaleLowerCase()))) &&
      (searchData?.EndDT === "" || (val?.EndDT && val?.EndDT?.toLocaleLowerCase().includes(searchData?.EndDT?.toLocaleLowerCase()))) &&
      (searchData?.CreatedBy === "" || (val?.CreatedBy && val?.CreatedBy?.toLocaleLowerCase().includes(searchData?.CreatedBy?.toLocaleLowerCase()))) &&
      (searchData?.CreatedDT === "" || (val?.CreatedDT && val?.CreatedDT?.toLocaleLowerCase().includes(searchData?.CreatedDT?.toLocaleLowerCase()))) 
      // &&
      // (searchData?.ModifiedBy === "" || (val?.ModifiedBy && val?.ModifiedBy?.toLocaleLowerCase().includes(searchData?.ModifiedBy?.toLocaleLowerCase()))) &&
      // (searchData?.ModifiedDT === "" || (val?.ModifiedDT && val?.ModifiedDT?.toLocaleLowerCase().includes(searchData?.ModifiedDT?.toLocaleLowerCase())))
    );
    setTableData(fiterData);
  }, [searchData]);
  const handleSearchData = (event, field) => {
    let value = event.target.value.toString(); // Convert value to string
    setSearchData({ ...searchData, [field]: value });
  }
  const handleResetLinkPlace = () => {
    setFilterValue((prev) => ({
      ...prev,
      startPlace: placeList,
      endPlace: placeList,
      linkPlace: placeList,
      status: statusList
    }))
  }
  const excelConfig = {
    columns: [],
    fileName: `Excel_Export.xlsx`,
    headerRowStyle: {
      font: {
        name: 'Calibri',
        family: 2,
        size: 11,
        bold: true,
        color: { argb: '00000000' },
      },
      alignment: { vertical: 'middle' },
      fill: {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'ffffffff' },
        bgColor: { argb: 'ffffffff' }
      }
    },
    borderStyle: {
      top: { style: 'thin', color: { argb: 'FFBDBDBD' } },
      left: { style: 'thin', color: { argb: 'FFBDBDBD' } },
      bottom: { style: 'thin', color: { argb: 'FFBDBDBD' } },
      right: { style: 'thin', color: { argb: 'FFBDBDBD' } }
    },
    pageSetup: {
      paperSize: 9,
      orientation: 'landscape',
      margins: {
        left: 0.5, right: 0.1, top: 0.4, bottom: 0.3, header: 0.1, footer: 0.1
      },
      fitToPage: true,
      fitToHeight: 0
    },
    defaultHeaderRowHeight: 20,
    defaultDataRowHeight: 20,
    showFilterSection: false,
    filterSectionData: null,
    workSheetTitle: 'Sheet 1',
    headerFooter: {
      firstHeader: null,
      firstFooter: null
    }
  }
  // for Export as excel
  const reportExcelExport = async () => {
    try {
      const xlColumns = LinkPlaceColumnDefsForPdfExcel.map(col => ({
        colHeader: col.headerName,
        field: col.field,
        xlCol: col.xlCol
      }));
      const excelTblData = tableData.map(item => {
        return {
          ...item, isDataRow: true,
          IsActive: item.IsActive === 1 ? 'Active' : 'InActive',
          StartDT: (item.StartDT !== '' && item.StartDT !== null) ? moment(item.StartDT).format('DD-MMM-YYYY') : '',
          EndDT: (item.EndDT !== '' && item.EndDT !== null) ? moment(item.EndDT).format('DD-MMM-YYYY') : '',
          CreatedDT: (item.CreatedDT !== '' && item.CreatedDT !== null) ? moment(item.CreatedDT).format('DD-MMM-YYYY') : '',
          ModifiedDT: (item.ModifiedDT !== '' && item.ModifiedDT !== null) ? moment(item.ModifiedDT).format('DD-MMM-YYYY') : ''
        };
      });
      const xlConfig = {
        ...excelConfig,
        columns: xlColumns,
        fileName: `Link_Place_Config.xlsx`,
        showFilterSection: false,
        showSummarySection: false,
        showEmptyRow: true,
        headerRowStyle: { fill: '', bold: true },
        borderStyle: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        },
        showHeader: true,
        workSheetTitle: `Link Place Config`,
        headerFooter: {
          firstHeader: "Link Place Config",
          firstFooter: "Link Place Config"
        },
        sheetHeaderData: [
          {
            "caption": "KARNATAKA STATE ROAD TRANSPORT CORPORATION",
            "colSpan": LinkPlaceColumnDefsForPdfExcel.length,
            "horizontal": "center",
            "newRow": true
          },
          {
            "caption": "Link Place Config",
            "colSpan": LinkPlaceColumnDefsForPdfExcel.length,
            "size": 12,
            "horizontal": "center",
            "newRow": true
          },
          {
            "caption": `${LoginId} / ${moment(window.getTime ? window.getTime() : new Date()).format('DD/MMM/YYYY HH:mm:ss')}`,
            "colSpan": LinkPlaceColumnDefsForPdfExcel.length,
            "horizontal": "right",
            "size": 10,
            "newRow": true
          },
        ],
      };
      await excelExport.processExcel(xlConfig, excelTblData, []);
    } catch (err) {
      console.log(err);
    }
  }
  const generatePdf = (isSave) => {
    if (!isSave) {
      dispatch(updateLoadingScreen(true));
    }
    setState({ ...state, load: true, generatePDF: true })
    const doc = new jsPDF({
      orientation: 'p',
      format: [983, 1391],
      unit: 'px',
      compress: true
    });
    doc.autoTableSetDefaults({
      headStyles: { fontSize: 16, width: 'auto', halign: 'left', fillColor: [255, 255, 255] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Link Place Configuration.pdf`,
      subject: 'Link Place Configuration',
      author: 'Mantis Technologies Private Limited',
      keywords: 'mantis, KSRTC, Link Place Configuration Report',
      creator: 'MTPL',
    })
    const pdfColumns = LinkPlaceColumnDefsForPdfExcel.map(col => ({
      header: col.exportHead,
      dataKey: col.field,
      xlCol: col.xlCol
    }));
    const pdfTableData = tableData.map(item => {
      return {
        ...item,
        IsActive: item.IsActive === 1 ? 'Active' : 'InActive',
        StartDT: (item.StartDT !== '' && item.StartDT !== null) ? moment(item.StartDT).format('DD-MMM-YYYY') : '',
        EndDT: (item.EndDT !== '' && item.EndDT !== null) ? moment(item.EndDT).format('DD-MMM-YYYY') : '',
        CreatedDT: (item.CreatedDT !== '' && item.CreatedDT !== null) ? moment(item.CreatedDT).format('DD-MMM-YYYY') : '',
        ModifiedDT: (item.ModifiedDT !== '' && item.ModifiedDT !== null) ? moment(item.ModifiedDT).format('DD-MMM-YYYY') : ''
      };
    });
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 0 },
      startY: 105,
      theme: 'grid',
      head: [],
      body: [['Link Place Configuration']],
      columnStyles: {
        0: { halign: 'left', font: 'Roboto', fontSize: 14, minCellHeight: 35, cellPadding: 6, valign: 'middle', textColor: [0, 0, 0], fontWeight: 600 },
      },
      bodyStyles: {
        cellPadding: { top: 6, right: 6, bottom: 6, left: 6 },
        minCellHeight: 35,
        valign: 'middle',
        font: 'Roboto',
        fontStyle: 'bold',
        fontSize: 14,
        halign: 'left',
      },
      didParseCell: function (data) {
        if (data.row.index === 0) {
          data.cell.styles.textColor = '#000000'
        }
      },
      didDrawPage: function (data) {
        var doc = data.doc;
        doc.setTextColor('#000000');

        var text1 = 'KARNATAKA STATE ROAD TRANSPORT CORPORATION';
        var textWidth1 = doc.getStringUnitWidth(text1) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        var centerX1 = (doc.internal.pageSize.width - textWidth1) / 2;

        doc.setFontSize(18).setFont("Roboto", 'normal', '700');
        doc.setTextColor('#000000');
        doc.text(text1, centerX1, 40);

        doc.setFontSize(14).setFont("Roboto", 'normal', '600');
        doc.setTextColor('#000000');

        var text2 = 'Link Place Configuration';
        var textWidth2 = doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        var centerX2 = (doc.internal.pageSize.width - textWidth2) / 2;
        doc.text(text2, centerX2 + 20, 60); // Adjust the vertical position as needed
        doc.setFontSize(14)
        doc.setFont('Roboto', 'bold')
        doc.text(`${LoginId} / ${moment(window.getTime ? window.getTime() : new Date()).format('DD/MMM/YYYY HH:mm:ss')}`, doc.internal.pageSize.width - data.settings.margin.left, 90, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 30, left: 30, right: 30, bottom: 60 },
      startY: doc.lastAutoTable.finalY,
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      theme: 'grid',
      columns: pdfColumns,
      columnStyles: {
        0: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 114.5, textColor: [0, 0, 0], fontStyle: 'normal' },
        1: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 98.5, textColor: [0, 0, 0], fontStyle: 'normal' },
        2: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 80, textColor: [0, 0, 0], fontStyle: 'normal' },
        3: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 70, textColor: [0, 0, 0], fontStyle: 'normal' },
        4: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 70, textColor: [0, 0, 0], fontStyle: 'normal' },
        5: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 70, textColor: [0, 0, 0], fontStyle: 'normal' },
        6: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 70, textColor: [0, 0, 0], fontStyle: 'normal' },
        7: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 70, textColor: [0, 0, 0], fontStyle: 'normal' },
        8: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 90, textColor: [0, 0, 0], fontStyle: 'normal' },
        9: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 90, textColor: [0, 0, 0], fontStyle: 'normal' },
        10: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 50, textColor: [0, 0, 0], fontStyle: 'normal' },
        11: { halign: 'left', fontSize: 14, minCellHeight: 16, cellPadding: 6, valign: 'middle', minCellWidth: 50, textColor: [0, 0, 0], fontStyle: 'normal' },
      },
      showHead: 'everyPage',
      body: pdfTableData,
      tableLineWidth: 0.6,
      rowPageBreak: 'avoid',
      styles: {
        cellPadding: { top: 5, right: 6, bottom: 5, left: 6 },
        minCellHeight: 35,
        valign: 'top',
        lineWidth: [1, 0, 1, 0],
        fontSize: 12,
        textColor: '#000000'
      },
      headStyles: {
        fontSize: 12,
        valign: 'middle',
        fontWeight: 600

      },
      didParseCell: (data) => {
        if (data.row.section === 'head' || data.row.section === 'body') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = 'right'
          } else {
            data.cell.styles.halign = 'left'
          }
        }

      },
    })
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Places ${new Date().getTime()}.pdf`)

    } else {
      setTimeout(() => {
        dispatch(updateLoadingScreen(false));
        const newTab = window.open();
        newTab.document.write('<iframe width="100%" height="100%" src="' + doc.output('datauristring', 'Places') + '"></iframe>');
      }, 20)
    }
  }
  const startPlaceProps = () => {
    return {
      id: 'startPlace',
      width: "100%",
      name: "startPlace",
      label: "Start Place",
      isCompulsory: false,
      options: placeList,
      optionLimit: 50,
      preSelectedValues: filterValue?.startPlace,
      searchPlaceholder: "Search by start Place",
      disabled: false,
      isObject: true,
      primaryKey: 'CityID',
      labelKey: 'ActualCityName',
      searchByCode: true,
      searchByName: "CityShortName",
      singleSelect: true,
      selectAllOption: true,
      defaultAllSelected: true,
      listWidth: "max-content",
      prevId: 'placeCode',
      nextId: 'stateName'
    }
  }
  const endPlaceProps = () => {
    return {
      id: 'endPlace',
      width: "100%",
      name: "endPlace",
      label: "End Place",
      isCompulsory: false,
      options: placeList,
      optionLimit: 50,
      preSelectedValues: filterValue?.endPlace,
      searchPlaceholder: "Search by Place Name",
      disabled: false,
      isObject: true,
      primaryKey: 'CityID',
      labelKey: 'ActualCityName',
      searchByCode: true,
      searchByName: "CityShortName",
      singleSelect: true,
      selectAllOption: true,
      defaultAllSelected: true,
      listWidth: "max-content",
      prevId: 'placeCode',
      nextId: 'stateName'
    }
  }
  const linkPlaceProps = () => {
    return {
      id: 'linkPlace',
      width: "100%",
      name: "linkPlace",
      label: "Link Place",
      isCompulsory: false,
      options: placeList,
      optionLimit: 50,
      preSelectedValues: filterValue?.linkPlace,
      searchPlaceholder: "Search by Place Name",
      disabled: false,
      isObject: true,
      primaryKey: 'CityID',
      labelKey: 'ActualCityName',
      searchByCode: true,
      searchByName: "CityShortName",
      singleSelect: true,
      selectAllOption: true,
      defaultAllSelected: true,
      listWidth: "max-content",
      prevId: 'placeCode',
      nextId: 'stateName'
    }
  }
  const statusProps = () => {
    return {
      id: 'status',
      width: "100%",
      name: "status",
      label: "Status",
      isCompulsory: false,
      options: statusList,
      preSelectedValues: filterValue?.status,
      searchPlaceholder: "Search by Place Name",
      disabled: false,
      isObject: true,
      primaryKey: 'id',
      labelKey: 'name',
      searchByCode: true,
      searchByName: "CityShortName",
      singleSelect: true,
      selectAllOption: true,
      defaultAllSelected: true,
      listWidth: "max-content",
      prevId: 'placeCode',
      nextId: 'stateName'
    }
  }
  return (
    <Box className="masterConfig_container">
      {!(masterEdit || masterAdd || masterView) &&
        <>
          <ReportHeader headerName={'Link Place Configuration'} mainHeaderName="Master Configuration" openSubMenu={() => dispatch(masterConfigMenuVSBL(true))} fixedTopPosition={true} />
          <Grid container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            flexWrap='nowrap'
            columnSpacing={{ xs: 1.5 }}
            sx={{
              padding: "16px",
            }}
          >
            <Grid item md={2.8}>
              <MultiSelectDropDown
                {...startPlaceProps()}
                onSelect={(val) => {
                  setFilterValue(prev => ({ ...prev, startPlace: val }));
                  // let filterListLink = filterOpt?.linkPlace?.filter((city) => city.CityID !== val[0]?.CityID)
                  // let filterListEnd = filterOpt?.endPlace?.filter((city) => city.CityID !== val[0]?.CityID)
                  // setFilterOpt((prev) => ({ ...prev, endPlace: filterListEnd, linkPlace: filterListLink }))
                }}
            
              />
            </Grid>
            <Grid item md={2.8}>
              <MultiSelectDropDown
                {...endPlaceProps()}
                onSelect={(val) => {
                  setFilterValue(prev => ({ ...prev, endPlace: val }));
                  // let filterListLink = filterOpt?.linkPlace?.filter((city) => city.CityID !== val[0]?.CityID)
                  // let filterListstart = filterOpt?.startPlace?.filter((city) => city.CityID !== val[0]?.CityID)
                  // setFilterOpt((prev) => ({ ...prev, startPlace: filterListstart, linkPlace: filterListLink }))
                }}
            
              />
            </Grid>
            <Grid item md={2.8}>
              <MultiSelectDropDown
                {...linkPlaceProps()}
                onSelect={(val) => {
                  setFilterValue(prev => ({ ...prev, linkPlace: val }));
                  // let filterListStart = filterOpt?.startPlace?.filter((city) => city.CityID !== val[0]?.CityID)
                  // let filterListEnd = filterOpt?.endPlace?.filter((city) => city.CityID !== val[0]?.CityID)
                  // setFilterOpt((prev) => ({ ...prev, startPlace: filterListStart, endPlace: filterListEnd }))
                }}
             
              />
            </Grid>
            <Grid item md={1.5}>
              <MultiSelectDropDown
                {...statusProps()}
                onSelect={(val) => { setFilterValue((prev) => ({ ...prev, status: val })) }}
              />
            </Grid>
            <Grid item md={1}>
              <Button id='lvSearchBtn' variant="contained" size="medium"
                className={`btn-orange`}
                onClick={() => {
                  getTableData()
                }}
                onKeyDown={(e) => navigation3(e, "lvResetBtn", "levyType", () => getTableData())}
              >
                Search
              </Button>
            </Grid>
            <Grid item md={1}>
              <Button
                id='lvResetBtn'
                variant="outlined"
                size="medium"
                className="btn-orange-outline"
                onClick={() => { handleResetLinkPlace() }}
                onKeyDown={(e) => navigation3(e, "lvAdd", "lvSearchBtn", () => handleResetLinkPlace())}
              >
                RESET
              </Button>
            </Grid>
            <Divider orientation="vertical" flexItem sx={{ width: '2px', margin: '0px 0px 0px 10px !important' }} />
            <Grid item md={2}>
              <Button
                id='lvAdd'
                variant="outlined"
                size="medium"
                className="btn-orange-outline"
                startIcon={
                  <FontAwesomeIcon icon={faPlus} />
                }
                onClick={() => {
                  handleAdd(true)
                }}
                onKeyDown={(e) => navigation3(e, "lvCorpCode", "lvResetBtn", () => handleAdd(true))}
              >
                Add Link Place
              </Button>
            </Grid>
          </Grid>
          <Divider />
          <Box sx={{ padding: '12px 16px' }}>
            <TableContainer className='scrollBlue' component={Paper} sx={{
              maxHeight: '50vh', marginBottom: "5px",
            }} >
              <Table stickyHeader size="small" aria-label="a dense table"
                sx={{
                  '& .MuiTableCell-root': {
                    padding: '6px 8px !important',
                  },
                  '& .MuiTableCell-root': {
                    padding: '6px 8px',
                    fontSize: '14px !important'
                  },
                }}
              >
                <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                  <TableRow>
                    <TableCell colSpan={LinkPlaceColumnDefs?.length} sx={{ backgroundColor: "#CCE7FF", height: "36px" }}>
                      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                        <Typography style={{ fontSize: '14px', fontWeight: '600', color: '#202020', }}>Link Place Listing</Typography>
                        <Box>
                          <Button
                            startIcon={<svg width="13" height="17" viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M2.375 0.5C1.20293 0.5 0.25 1.39688 0.25 2.5V14.5C0.25 15.6031 1.20293 16.5 2.375 16.5H10.875C12.0471 16.5 13 15.6031 13 14.5V5.5H8.75C8.1623 5.5 7.6875 5.05312 7.6875 4.5V0.5H2.375ZM8.75 0.5V4.5H13L8.75 0.5ZM5.41973 8.31875L6.625 9.94063L7.83027 8.31875C8.08262 7.97813 8.58066 7.89687 8.93926 8.13438C9.29785 8.37188 9.3875 8.84063 9.13516 9.17813L7.59785 11.25L9.13848 13.3188C9.39082 13.6594 9.30449 14.125 8.94258 14.3625C8.58066 14.6 8.08594 14.5188 7.83359 14.1781L6.625 12.5562L5.41973 14.1781C5.16738 14.5188 4.66934 14.6 4.31074 14.3625C3.95215 14.125 3.8625 13.6562 4.11484 13.3188L5.65215 11.25L4.11152 9.18125C3.85918 8.84062 3.94551 8.375 4.30742 8.1375C4.66934 7.9 5.16406 7.98125 5.41641 8.32188L5.41973 8.31875Z" fill="#004F9E" />
                            </svg>
                            }
                            variant="contained"
                            color="primary"
                            style={{ ...transparentStyle }}
                            onClick={() => reportExcelExport()}
                          >
                            Export As Excel
                          </Button>
                          <Button
                            startIcon={<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.50033 9.41699H7.33366V7.75033H8.16699C8.4031 7.75033 8.60102 7.67046 8.76074 7.51074C8.92046 7.35102 9.00033 7.1531 9.00033 6.91699V6.08366C9.00033 5.84755 8.92046 5.64963 8.76074 5.48991C8.60102 5.33019 8.4031 5.25033 8.16699 5.25033H6.50033V9.41699ZM7.33366 6.91699V6.08366H8.16699V6.91699H7.33366ZM9.83366 9.41699H11.5003C11.7364 9.41699 11.9344 9.33713 12.0941 9.17741C12.2538 9.01769 12.3337 8.81977 12.3337 8.58366V6.08366C12.3337 5.84755 12.2538 5.64963 12.0941 5.48991C11.9344 5.33019 11.7364 5.25033 11.5003 5.25033H9.83366V9.41699ZM10.667 8.58366V6.08366H11.5003V8.58366H10.667ZM13.167 9.41699H14.0003V7.75033H14.8337V6.91699H14.0003V6.08366H14.8337V5.25033H13.167V9.41699ZM5.66699 14.0003C5.20866 14.0003 4.8163 13.8371 4.48991 13.5107C4.16352 13.1844 4.00033 12.792 4.00033 12.3337V2.33366C4.00033 1.87533 4.16352 1.48296 4.48991 1.15658C4.8163 0.830187 5.20866 0.666992 5.66699 0.666992H15.667C16.1253 0.666992 16.5177 0.830187 16.8441 1.15658C17.1705 1.48296 17.3337 1.87533 17.3337 2.33366V12.3337C17.3337 12.792 17.1705 13.1844 16.8441 13.5107C16.5177 13.8371 16.1253 14.0003 15.667 14.0003H5.66699ZM2.33366 17.3337C1.87533 17.3337 1.48296 17.1705 1.15658 16.8441C0.830187 16.5177 0.666992 16.1253 0.666992 15.667V4.00033H2.33366V15.667H14.0003V17.3337H2.33366Z" fill="#004F9E" />
                            </svg>
                            }
                            variant="contained"
                            color="primary"
                            style={{ ...transparentStyle }}
                            onClick={() => generatePdf(true)}
                          >
                            Export As PDF
                          </Button>
                          <Button
                            startIcon={<PrintIcon />}
                            variant="contained"
                            color="primary"
                            style={{ ...transparentStyle }}
                            onClick={() => generatePdf(false)}
                          >
                            Print
                          </Button>
                        </Box>
                      </Box>
                    </TableCell>
                  </TableRow>
                  <TableRow >
                    {LinkPlaceColumnDefs.map((col, index) => (
                      <TableCell
                        key={`THR-${index}`}
                        sx={{
                          ...col.headerSx,
                          height: "36px",
                          backgroundColor: '#E5F3FF',
                          color: '#202020',
                          fontSize: '12px',
                          fontWeight: '600',
                          whiteSpace: 'pre-line',
                          padding: '4px 12px 4px 12px',
                          lineHeight: 1.3
                        }}
                      >
                        {col.headerName}
                      </TableCell>))}
                  </TableRow>
                  <TableRow>
                    {LinkPlaceColumnDefs.map((col, index) => col.showFilter ?
                      <TableCell key={`FTH-${index}`} sx={{ height: '36px' }}>
                        <div className="filter-input" style={{}}>
                          <input
                            id={`filter-${index}`}
                            className="field"
                            name="cancelSearchInput"
                            style={{ width: '100%' }}
                            placeholder="Contains"
                            value={searchData[col.field]}
                            onChange={(e) => handleSearchData(e, col.field)}
                          />
                          <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                        </div>
                      </TableCell>
                      : <TableCell key={`empty-cell-${index}`}></TableCell>)}
                  </TableRow>
                </TableHead>
                {tableData?.length > 0 ? <TableBody>
                  {(
                    rowsPerPage > 0
                      ? tableData.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      : tableData
                  ).map((val, index) => {
                    return (
                      <TableRow key={`TD-${index}`} >
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '13.5%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>{val.FromCity}</TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '10.5%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>{val.LinkCity}</TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '13%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>{val.ToCity}</TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '13%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>{(val.StartDT !== '' && val.StartDT !== null) ? moment(val.StartDT).format('DD-MMM-YY') : ''}</TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '13%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>{(val.EndDT !== '' && val.EndDT !== null) ? moment(val.EndDT).format('DD-MMM-YY') : ''}</TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '13%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>{val.CreatedBy}</TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '13%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>{(val.CreatedDT !== '' && val.CreatedDT !== null) ? moment(val.CreatedDT).format('DD-MMM-YY,hh:mm A') : ''}</TableCell>
                        {/* <TableCell sx={{ height: '36px', fontSize: '12px', width: '13%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>{val.ModifiedBy}</TableCell>
                        <TableCell sx={{ height: '36px', fontSize: '12px', width: '13%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>{(val.ModifiedDT !== '' && val.ModifiedDT !== null) ? moment(val.ModifiedDT).format('DD-MMM-YY,hh:mm A') : ''}</TableCell> */}
                        <TableCell sx={{ height: '36px', fontSize: '12px', textAlign: 'center', width: '4.52%', color: '#444', fontWeight: '500', padding: '4px 12px 4px 12px' }}>
                          <Checkbox
                            sx={{
                              '&.Mui-disabled': {
                                border: 'none !important',
                                backgroundColor: 'transparent !important'
                              },
                              padding: 0,
                              width: '12px',
                              height: '12px'
                            }}
                            inputProps={{
                              'aria-label': 'Checkbox demo'
                            }}
                            checked={val.IsActive === 1}
                          />

                        </TableCell>
                        <TableCell sx={{ minWidth: '12.96%', padding: '4px 12px 4px 12px' }}>
                          <div style={{ fontSize: '12px', color: '#444', fontWeight: '500', display: "flex", gap: "20px", alignItems: "center", }}>
                            <span
                              style={{ display: 'flex', color: '#004F9E', fontWeight: 'bold', cursor: 'pointer', gap: '8px' }}
                              onClick={(e) => {
                                setData(val); handleEdits(true)
                              }}
                            >
                              <Edit />
                              Edit
                            </span>
                            <span
                              style={{ display: 'flex', color: '#004F9E', fontWeight: 'bold', cursor: 'pointer' }}
                              onClick={(e) => {
                                setData(val)
                                handleView(true)
                              }}
                            >
                              <VisibilityIcon sx={{ fontSize: "16px", marginRight: '3px' }} />
                              View
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody> :
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={10}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginBottom: '20px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          <span>No Results Found For The Selected Filters.</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>}
              </Table>
            </TableContainer>
            <TablePaginationCustom totRowCount={tableData?.length} rowsPerPageOptions={[10, 20, 30, { label: 'All', value: -1 }]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
              setPage(newPage)
            }} handleChangeRowsPerPage={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }} />
          </Box >
        </>}
      {masterEdit && <EditLevies handleEdits={handleEdits} data={data} getTableData={getTableData} />}
      {masterAdd && <AddLevies handleAdd={handleAdd} getTableData={getTableData} />}
      {masterView && <ViewLevies handleView={handleView} data={data} />}
      {showAlert?.open && <Alert msg={showAlert?.msg} alertType={'error'} close={handleAlertClose} buttonText="OK" />}
    </Box>
  )
}

export default LinkPlaceConfig
